import {decode as base64_decode, encode as base64_encode} from 'base-64';
import RootStore from './RootStore';
import { postApi,baseURL} from '../components/Utility'
import {
  action,
  
  makeObservable,
  observable,
 
} from 'mobx';
import config from "../config";
import { message } from "antd";


class IdleReportStore {
  idleReport=[]
  totalIdleArray=[]
  responseExcel=""
  total=0
  loading=false
  rootStore
  remaning_vehicleId = ""
  last_record_timestamp = ""
  pythonReportMessage=false
  pythonReportErrorMessage=false
  constructor(rootStore) {
    makeObservable(this, {
        idleReport: observable,
        totalIdleArray:observable,
      total:observable,
      loading:observable,
      remaning_vehicleId: observable,
      last_record_timestamp: observable,
      loadData:action,
      exportExcel:action,
      exportcsv:action,
      exportpdf:action,
      exportxml:action,
      totalIdleReport:action,
      pythonReportMessage:observable,
      pythonReportErrorMessage:observable

     
    });
     this.rootStore = rootStore;
    
  }

  async loadData({companyId,offset,limit,vehicleId,fromDate,toDate,interval,pageNo}) {
    this.loading=true
    var postData = {"companyId":companyId,"vehicleId":vehicleId,"fromDate":fromDate,"toDate":toDate,"interval":interval,"offset":offset,"limit":limit,"page":pageNo}
   
    if(config.pythonReport === 1){
      // postData.companyId=10166
      // postData.vehicleId=[26375]
      if(offset === 0){
        postData.last_record_timestamp = ""
        postData.remaning_vehicleId = ""
      }else{
        postData.last_record_timestamp = this.last_record_timestamp
        postData.remaning_vehicleId = this.remaning_vehicleId
      }
      var response = await postApi.getClient('report').post("/report/idle", postData);
      this.total = 500

    }else{
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi.getClient().post("index.php?c=vehicleidle&a=idlingreport", "postData="+base64Input);
      this.total = parseInt(response?.data?.data?.TotalCount);
    }

    if(config.pythonReport === 1){
      this.last_record_timestamp = response?.data?.data?.last_record_timestamp
      this.remaning_vehicleId = response?.data?.data?.remaning_vehicleId
    }

    this.idleReport =response?.data?.data?.idlingReport
    this.loading=false;

  }


  async totalIdleReport({offset,limit,companyId,fromDate,toDate,vehicleId,interval}) {
    if(config.pythonReport !== 1){
        this.loadingData=true
        var postData = {"companyId":companyId,"vehicleId":vehicleId,"fromDate":fromDate,"toDate":toDate,interval:interval,offset:offset,limit:limit}
        const base64Input = await base64_encode(JSON.stringify(postData));
        var response = await postApi.getClient().post("index.php?c=vehicle&a=totalIdleRep", "postData="+base64Input);   
        this.totalIdleArray = response?.data?.data
        // this.total = parseInt(response?.data?.data?.TotalCount);
        this.loadingData=false;
    }
  }


  async exportExcel(getData) {

    if(config.pythonReport === 1){

      getData = { ...getData, language: "english" }
      // getData = { ...getData, companyId: 10166 }
      // getData = { ...getData, vehicleId: [26375] }
      try {
  
        const res =   await postApi.getClient("report").post("/report/idle/download/excel", getData, {
              responseType: "blob",
          });

          this.pythonReportMessage=true;
          // await message.success("The report will be generated shortly. You can check its status in the pending report list.", 2);
         
      } catch (error) {
          this.pythonReportErrorMessage=true;
          message.error("Failed to download the report. Please try again.")
      }

    }else{
        let lang = "english";
        window.location.href =
          baseURL +
          "index.php?c=vehicleidle&a=exportidleexcel&cid=" +
          getData.companyId+
          "&userId=" +
        getData.userId+
          "&vid=" +
          getData.vehicleId+
          "&int="+
          getData.interval+
          "&fD=" +
          getData.fromDate +
          "&tD=" +
          getData.toDate +
          "&colList=" +
          getData.colList +
          "&language=" +
          lang;
    }

  }

  async exportpdf(getData) {

    if(config.pythonReport === 1){

        getData = { ...getData, language: "english" }
        // getData = { ...getData, companyId: 10166 }
        // getData = { ...getData, vehicleId: [26375] }
        try {
          // await message.success("fnv")
          // console.log("object",this.pythonReportMessage)
            await postApi.getClient("report").post("/report/idle/download/pdf", getData, {
                responseType: "blob",
            });
            this.pythonReportMessage=true;
            //await message.success("The report will be generated shortly. You can check its status in the pending report list.", 2);
          
        } catch (error) {
          this.pythonReportErrorMessage=true;
            message.error("Failed to download the report. Please try again.")
        }
        
    }else{
      let lang = "english";
      window.location.href =
        baseURL +
        "index.php?c=vehicleidle&a=exportidlepdf&cid=" +
        getData.companyId+
        "&userId=" +
      getData.userId+
        "&vid=" +
        getData.vehicleId+
        "&int="+
        getData.interval+
        "&fD=" +
        getData.fromDate+
        "&tD=" +
        getData.toDate+
        "&colList=" +
        getData.colList+
        "&language=" +
        lang;
    }

  }

  async exportcsv(getData) {
    let lang = "english";
    window.location.href =
      baseURL +
      "index.php?c=vehicleidle&a=exportidlecsv&cid=" +
      getData.companyId +
      "&userId=" +
     getData.userId+
      "&vid=" +
      getData.vehicleId +
      "&int="+
      getData.interval+
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList +
      "&language=" +
      lang;
  }
  async exportxml(getData) {
    let lang = "english";
    window.location.href =
      baseURL +
      "index.php?c=vehicleidle&a=exportidlexml&cid=" +
      getData.companyId +
      " &userId=" +
     getData.userId+
      "&vid=" +
      getData.vehicleId +
      "&int="+
      getData.interval+
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList +
      "&language=" +
      lang;
  }

  
  

}

export default IdleReportStore;
